import { UserIncludeFieldType } from '@csp/dmdp-api-user-dto';
import { ApiOptions, Author, UserId } from '@csp/csp-common-model';
import { CachedUserQueryService } from './CachedUserQueryService';

const byUserIds = async (userIds: UserId[], apiOptions?: ApiOptions): Promise<Author[]> => {
  const users = await CachedUserQueryService.byUserIds(userIds, [UserIncludeFieldType.HUMAN_NAME], apiOptions);
  return users.map(user => ({ userId: user.userId, displayName: user.displayName }));
};

export const AuthorQueryService = {
  byUserIds,
};
